// Shared typography tokens — import these instead of writing Tailwind strings inline.
export const SECTION_TITLE = "text-base font-bold text-foreground uppercase tracking-wide";
export const SECTION_SUBTITLE = "text-xs text-muted-foreground";
export const CONTENT_TEXT = "text-sm text-foreground";

// Category → owner mapping. Key is the slugified category name.
export const CATEGORY_OWNERS: Record<string, string> = {
  "platform-data-integrity":   "Infra Eng",
  "tutor-agent-behavior":      "AI / Agent Eng",
  "instructional-correctness": "Content + Eng",
  "content-lesson-design":     "Content Team",
  "student-engagement-outcome":"Product / Content",
  "other":                     "Other",
};

// Consistent Tailwind color per owner — edit here to restyle all badges at once.
export const OWNER_COLORS: Record<string, { bg: string; text: string }> = {
  "AI / Agent Eng":    { bg: "bg-violet-100 dark:bg-violet-900/40",  text: "text-violet-700 dark:text-violet-300" },
  "Infra Eng":         { bg: "bg-cyan-100 dark:bg-cyan-900/40",       text: "text-cyan-700 dark:text-cyan-300" },
  "Content + Eng":     { bg: "bg-orange-100 dark:bg-orange-900/40",   text: "text-orange-700 dark:text-orange-300" },
  "Content Team":      { bg: "bg-amber-100 dark:bg-amber-900/40",     text: "text-amber-700 dark:text-amber-300" },
  "Product / Content": { bg: "bg-pink-100 dark:bg-pink-900/40",       text: "text-pink-700 dark:text-pink-300" },
  "Other":             { bg: "bg-slate-100 dark:bg-slate-700/40",     text: "text-slate-600 dark:text-slate-300" },
};

export function slugify(name: string): string {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export function ownerForCategory(categoryName: string): string {
  const slug = slugify(categoryName);
  return CATEGORY_OWNERS[slug] ?? "Triage";
}

// Priority fix type tag colors — Easy Fix and Most Fundamental badges.
export const FIX_TYPE_COLORS = {
  easy:        "bg-green-700/70 text-green-50",
  fundamental: "bg-red-700/70 text-red-50",
};

// Severity badge colors — single source of truth used by SeverityBadge.tsx and BitePanel.
export const SEVERITY_BADGE: Record<string, string> = {
  critical:    "bg-red-700 text-white",
  major:       "bg-amber-600 text-white",
  minor:       "bg-yellow-900/60 text-yellow-300 border border-yellow-700",
  observation: "bg-blue-900/60 text-blue-300 border border-blue-700",
};
